import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

export class ParentFamilyName extends PrimitiveValueObject<string> {
  /**
   * 生成
   * @param value 値
   * @returns 値
   */
  static create(value: string): ParentFamilyName {
    if (!(value.length > 0)) {
      throw new Error('苗字が入力されていません');
    }
    return new ParentFamilyName(value);
  }

  /** ラベル */
  static get label(): string {
    return '苗字';
  }

  /** プレースホルダー */
  static get placeholder(): string {
    return '山田';
  }

  /** バリデーションルール */
  static get validationRule() {
    return {
      /** 必須 */
      required: '必須項目です',
    };
  }

  /** 文字列にする */
  override toString() {
    return this.value;
  }
}
